import "./index.css";
import "./i18n.js";
import reportWebVitals from "./reportWebVitals";
import * as ReactDOM from "react-dom/client";
import Router from "./Router/Router";
import { ThemeProvider } from "@emotion/react";
import theme from "./Themes/Theme";
import { ToastContainer } from "react-toastify";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Loading from "./Utils/Loading";
import GDPRClient from "./Pages/GDPRClient";
import OrdersForCustomer from "./Pages/OrdersForCustomers";
import ServiceDoorToDoor from "./Pages/Templates/ServiceDoorToDoorTemplate";

if (window.location.pathname.includes("gdprClient")) {
  ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <ThemeProvider theme={theme}>
      <ToastContainer />
      <BrowserRouter>
        <Routes>
          <Route
            path="/gdprClient/:customerId/:orderId"
            element={<GDPRClient />}
          />
        </Routes>
      </BrowserRouter>
      <Loading />
    </ThemeProvider>
  );
} else if (window.location.pathname.includes("ordersForCustomer")) {
  ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <ThemeProvider theme={theme}>
      <ToastContainer />
      <BrowserRouter>
        <Routes>
          <Route
            path="/ordersForCustomer/:customerId"
            element={<OrdersForCustomer />}
          />
        </Routes>
      </BrowserRouter>
      <Loading />
    </ThemeProvider>
  );
} else if (window.location.pathname.includes("serviceDor2DorRequests")) {
  ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <ThemeProvider theme={theme}>
      <ToastContainer />
      <BrowserRouter>
        <Routes>
          <Route
            path="/serviceDor2DorRequests"
            element={<ServiceDoorToDoor />}
          />
        </Routes>
      </BrowserRouter>
      <Loading />
    </ThemeProvider>
  );
}
else {
  ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    // <React.StrictMode>
    <Router />
    // </React.StrictMode>
  );
}

reportWebVitals();
